<div id="wrap" class="moWrap">
  <header class="header">
      <div class="header_inner">
          <h1 class="header_logo">
              <a href="" class="logo"><img src="/assets/images/web/logo/logo_348.png" alt="OASIS BUDDY" /></a>
              <a href="https://www.oasis.co.kr" target="_blank" class="btn_oasis ico_blank">오아시스마켓</a>
          </h1>
          <span class="util_right">
            <button type="button" class="db_box_sub" (click)="logout()"><b>LOGOUT</b></button>
          </span>
      </div>
  </header>

  <div id="content">
    <div id="skip_anchor" class="content page_mypage">
      <p class="top_notice">버디활동(등록/수정 등)은 PC에서만 가능합니다.</p>
      <a routerLink="/m/link" class="top_btn"><b>버디링크</b> 만들기</a>
      <div class="dis_flex dis_flex-gap">
          <div class="db_box_inner">
              <strong class="db_box_title">내 정보</strong>
              <div class="db_box">
                  <div class="db_box_cont">
                      <dl class="db_info">
                          <dt class="db_info_title">이름</dt>
                          <dd class="db_info_text">{{user.userName}}</dd>
                          <dt class="db_info_title">핸드폰번호</dt>
                          <dd class="db_info_text">{{user.tel | tel}}</dd>
                          <dt class="db_info_title">아이디</dt>
                          <dd class="db_info_text">{{user.userId}} <button type="button" (click)="openMypageCommonPopup('gradeInfo')" class="btn_grade {{user.userGrade === 'G2' ? 'btn-grade2' : 'btn-grade1'}}">{{user.userGradeName}}</button></dd>
                          <dt class="db_info_title">가입일</dt>
                          <dd class="db_info_text">{{user.regDate | defaultDate}}</dd>
                          <dt class="db_info_title">상태</dt>
                          <dd class="db_info_text" *ngIf="user.status == 'RD'"><span class="col-green">승인대기</span></dd>
                          <dd class="db_info_text" *ngIf="user.status == 'ON'">승인완료</dd>
                          <dd class="db_info_text" *ngIf="user.status == 'RJ'">반려
                              <button type="button" (click)="openConfirmPopup('RJ')" class="fs-14 col-red underline ml-7">반려사유</button>
                              <!-- <button type="button" (click)="openConfirmPopup('RR')" class="db_info_text_button">재승인요청</button> -->
                          </dd>
                      </dl>
                  </div>
              </div>
          </div>

          <!-- <div class="banner">
              <a routerLink="/openEvent"><img src="/assets/images/mobile/temp/temp_2.jpg" alt="EVENT 최대 2만 포인트 보장! 오아시스버디 챌린지 참여하기 >" /></a>
          </div> -->

          <div class="db_box_inner">
            <strong class="db_box_title">내 실적 <span class="db_box_title_sub">(최근 1개월)</span> <a routerLink="/m/account/history" class="db_box_sub">더보기</a></strong>

            <!-- table-세로 -->
            <div class="table-row">
                <table class="table">
                    <thead>
                        <tr>
                            <th scope="col">링크명</th>
                            <th scope="col">구매건수</th>
                            <th scope="col">구매금액</th>
                            <th scope="col">예상수익</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr *ngFor="let item of list">
                            <td>
                              <div class="dis_flex">
                                  <div class="img_area">
                                    <a href="https://www.oasis.co.kr{{item.urlValue}}" target="_blank">
                                        <img src="{{item.filePath}}" alt="썸네일 이미지" onerror="this.src='/assets/images/web/img/img_onerrer.jpg'">
                                    </a>
                                  </div>
                                  <a class="info_area line-2">
                                      {{item.title}}
                                  </a>
                              </div>
                            </td>
                            <td>{{item.buyEventCount | number}}</td>
                            <td>{{item.totalPayment | number}}</td>
                            <td>{{item.commissionPrice | number}}</td>
                        </tr>
                        <ng-container *ngIf="!(list && list.length > 0)">
                            <tr>
                                <td colspan="4" class="nodata">내역이 없습니다.</td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>
            </div>
          </div>

          <div class="db_box_inner account">
              <strong class="db_box_title">수익금 지급 정보<span class="db_box_sub">PC에서 수정 가능</span></strong>
              <div class="db_box">
                  <div class="db_box_cont">
                      <dl class="db_info">
                          <dt class="db_info_title">계좌번호</dt>
                          <dd class="db_info_text" *ngIf="!userPaymentInfo">등록된 계좌가 없습니다.</dd>
                          <dd class="db_info_text" *ngIf="userPaymentInfo">{{userPaymentInfo.bankCodeName ?? userPaymentInfo.bankCode}} / {{userPaymentInfo.depositor ?? '예금주(미입력)'}} / {{userPaymentInfo.accountNumber}}</dd>
                          <ng-container *ngIf="user.userType == 'UT1'">
                            <dt class="db_info_title">주민등록번호</dt>
                            <dd class="db_info_text">
                                <span class="regident_number">{{user.regidentNumber ?? '-'}}</span>
                                <p class="pos_hover" *ngIf="!user.regidentNumber">
                                  &#8251; 수익금 지급은 월단위의 수익금이 최소 1만원이 넘으면 지급받을 수 있습니다. <br />
                                  &#8251; 개인의 경우 대금 정산을 위하여 주민등록번호 정보가 제공되어야 합니다.
                                </p>
                            </dd>
                        </ng-container>
                        <ng-container *ngIf="user.userType != 'UT1'">
                            <dt class="db_info_title">사업자등록번호</dt>
                            <dd class="db_info_text"><span *ngIf="user.corpCode">{{user.corpCode | corpCode}} </span></dd>
                            <!--
                                <dt class="db_info_title" *ngIf="user.corpCode">세금계산서 <b>{{user.cashbillYn === 'Y' ? '제공' : '미제공'}}</b></dt>
                            -->
                        </ng-container>
                      </dl>
                  </div>
              </div>
          </div>
          <div class="db_box_inner">
              <strong class="db_box_title">활동정보</strong>
              <div class="db_box">
                  <div class="db_box_cont">
                      <ol class="db_box_list">
                          <li class="db_list" *ngFor="let item of channelList; let idx = index;">
                            <span class="db_list-number">{{idx + 1}}</span>
                            <span class="db_list-channel">{{item.channelTypeName}}</span>
                            <a href="{{item.channelUrl}}" target="_blank" class="db_list-url ellipsis">{{item.channelUrl}}</a>
                          </li>
                      </ol>
                  </div>
              </div>
          </div>

          <div class="db_box_inner">
              <strong class="db_box_title">공지사항 <span class="db_box_sub">PC에서 확인 가능</span></strong>
              <div class="db_box">
                  <div class="db_box_cont">
                      <ul class="dv_voc_list">
                          <ng-container *ngIf="noticeList && noticeList.length > 0">
                              <li class="db_voc_li" *ngFor="let item of noticeList">
                                    <p class="ellipsis">{{item.title}}</p>
                                    <span class="date">{{item.regDate | date : 'yyyy-MM-dd'}}</span>
                              </li>
                          </ng-container>
                          <ng-container *ngIf="!(noticeList && noticeList.length > 0)">
                              <li class="db_voc_li">등록된 공지가 없습니다.</li>
                          </ng-container>
                      </ul>
                  </div>
              </div>
          </div>
          <div class="db_box_inner">
            <strong class="db_box_title">내 문의 <span class="db_box_sub">PC에서 확인 가능</span></strong>
              <div class="db_box">
                  <ul class="dv_voc_list">
                      <ng-container *ngIf="qnaList && qnaList.length > 0">
                          <li class="db_voc_li" *ngFor="let item of qnaList">
                                <p class="ellipsis">{{item.title}}</p>
                          </li>
                      </ng-container>
                      <ng-container *ngIf="!(qnaList && qnaList.length > 0)">
                          <li class="db_voc_li">등록된 문의가 없습니다.</li>
                      </ng-container>
                  </ul>
              </div>
          </div>

          <div class="db_box_inner">
              <strong class="db_box_title">로그인 이력</strong>
              <div class="db_box">
                <div class="db_box_cont">
                    <ng-container *ngIf="loginHistoryList && loginHistoryList.length > 0">
                    <dl class="db_info">
                        <div *ngFor="let item of loginHistoryList" class="db_info_item">
                          <dt class="db_info_title">일시</dt>
                          <dd class="db_info_text">{{item.regDate | defaultDate}}</dd>
                          <dt class="db_info_title">로그인 IP</dt>
                          <dd class="db_info_text">{{item.clientIp}}</dd>
                          <dt class="db_info_title">운영체제</dt>
                          <dd class="db_info_text">{{item.os}}</dd>
                          <dt class="db_info_title">브라우저</dt>
                          <dd class="db_info_text">{{item.browser}}</dd>
                        </div>
                    </dl>
                    </ng-container>
                    <ng-container *ngIf="!(loginHistoryList && loginHistoryList.length > 0)">
                        <p class="nodata">내역이 없습니다.</p>
                    </ng-container>
                </div>
              </div>
          </div>

          <div class="db_box_inner">
              <strong class="db_box_title">기타 이력</strong>
              <div class="db_box">
                <div class="db_box_cont">
                    <ng-container *ngIf="etcHistoryList && etcHistoryList.length > 0">
                    <dl class="db_info">
                        <div *ngFor="let item of etcHistoryList" class="db_info_item">
                          <dt class="db_info_title">내용</dt>
                          <dd class="db_info_text">{{item.activityInfo}}</dd>
                          <dt class="db_info_title">일시</dt>
                          <dd class="db_info_text">{{item.regDate | defaultDate}}</dd>
                          <dt class="db_info_title">로그인 IP</dt>
                          <dd class="db_info_text">{{item.clientIp}}</dd>
                          <dt class="db_info_title">운영체제</dt>
                          <dd class="db_info_text">{{item.os}}</dd>
                          <dt class="db_info_title">브라우저</dt>
                          <dd class="db_info_text">{{item.browser}}</dd>
                        </div>
                    </dl>
                    </ng-container>
                    <ng-container *ngIf="!(etcHistoryList && etcHistoryList.length > 0)">
                        <p class="nodata">내역이 없습니다.</p>
                    </ng-container>
                </div>
              </div>
          </div>
      </div>
    </div>
  </div>

  <!-- <footer class="footer">
      <div class="footer_inner">
          <div class="footer_menu">
              <a routerLink="/m/guide">이용가이드</a>
              <a href="https://www.oasis.co.kr/help/privacy" target="_blank" title="새창" class="emphasis">개인정보처리방침</a>
              <a routerLink="/terms">약관 및 정책</a>
          </div>
      </div>
  </footer> -->
</div>
